import { AutocompleteWithLabel, InputWithLabel } from '@adotel/components'
import {
  LazyQueryExecFunction,
  OperationVariables,
  useLazyQuery,
  useQuery
} from '@apollo/client'
import SearchIcon from '@material-ui/icons/Search'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { ENTITY_LIST_QUERY } from '../../graphql/entityList'
import { ROLES_QUERY } from '../../graphql/role'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { EntityList } from '../../types/entityList'
import { EntityType } from '../../types/reserveMonitoringList'
import { RoleBrief } from '../../types/role'
import { UserList, UserListFilters } from '../../types/users'
import useStyles from './styles/UsersFilters.styles'

interface UsersFilterProps {
  getUsers: LazyQueryExecFunction<
    {
      users: UserList
    },
    OperationVariables
  >
  filters: UserListFilters
  setFilters: React.Dispatch<React.SetStateAction<UserListFilters>>
}

const UsersFilters: React.FC<UsersFilterProps> = ({
  getUsers,
  filters,
  setFilters
}) => {
  const classes = useStyles()
  const [debouncedValue, setDebouncedValue] = useState(filters.searchInput)
  const [autoCompleteForRole, setAutoCompleteForRele] = useState<any>(null)
  const [autoCompleteForEntity, setAutoCompleteForEntity] = useState<any>(null)
  const delay = 1000

  const { data: rolesData } = useQuery<{
    roles: RoleBrief[]
  }>(ROLES_QUERY, {
    variables: { filters: {} },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })

  const [getEntityList, { data: entityListData }] = useLazyQuery<{
    entityList: EntityList[]
  }>(ENTITY_LIST_QUERY, {
    onError: (err) => {
      toast.error(err.message)
    }
  })
  useEffect(() => {
    if (autoCompleteForRole && autoCompleteForRole.value)
      getEntityList({
        variables: {
          entityType: autoCompleteForRole.value
        }
      })
  }, [autoCompleteForRole])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(filters.searchInput)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [filters.searchInput])

  useEffect(() => {
    getUsers({
      variables: {
        filters: {
          ...filters,
          searchInput: debouncedValue
        }
      }
    })
  }, [debouncedValue])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(filters.searchInput)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [filters.searchInput])

  useEffect(() => {
    getUsers({
      variables: {
        filters: {
          ...filters,
          searchInput: debouncedValue
        }
      }
    })
  }, [debouncedValue])

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <AutocompleteWithLabel
          options={
            rolesData && rolesData?.roles.length > 0
              ? rolesData?.roles.map((role) => ({
                  label: role.name,
                  id: role.roleID,
                  value: (role.entityType as EntityType) || ''
                }))
              : []
          }
          inputSize="small"
          getOptionLabel={(option) => option.label || ''}
          value={autoCompleteForRole}
          onChange={(_, value: any) => {
            if (value) {
              setAutoCompleteForRele({
                value: value.value,
                id: value.id,
                label: value.label
              })
              setFilters((prev) => {
                if (value.value) {
                  return {
                    ...prev,
                    role: value.label,
                    entityType: value.value
                  }
                } else {
                  return {
                    ...prev,
                    role: value.label,
                    entityType: undefined,
                    pagination: { page: 1, perPage: 8 }
                  }
                }
              })
            } else {
              setAutoCompleteForRele(null)
              setFilters({
                ...filters,
                role: undefined,
                entityCodes: [],
                entityType: undefined
              })
            }
          }}
          label={getTranslate('Role')}
          noHelperText
        />
        {autoCompleteForRole && autoCompleteForRole.value && (
          <InputWithLabel
            label={getTranslate('Entity Type')}
            fullWidth
            inputSize="small"
            value={(autoCompleteForRole && autoCompleteForRole.value) || ''}
            disabled
            noHelperText
          />
        )}
        {autoCompleteForRole && autoCompleteForRole.value && (
          <AutocompleteWithLabel
            options={
              entityListData?.entityList
                ? entityListData?.entityList.map((entity) => ({
                    label: entity.label,
                    value: entity.entityCode
                  }))
                : []
            }
            inputSize="small"
            noHelperText
            getOptionLabel={(option) => option.label || ''}
            value={autoCompleteForEntity}
            onChange={(_, value: any) => {
              if (value) {
                setAutoCompleteForEntity({
                  value: value.value,
                  label: value.label
                })
                if (filters.role) {
                  setFilters((prev) => ({
                    ...prev,
                    pagination: { page: 1, perPage: 8 },
                    entityCodes: [value.value]
                  }))
                }
              } else {
                setAutoCompleteForEntity(null)
              }
            }}
            label={getTranslate('Entity')}
          />
        )}
      </div>
      <div className={classes.row}>
        <InputWithLabel
          placeholder={getTranslate('Search by name or email')}
          // autoComplete="off"
          inputSize="small"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          value={filters.searchInput}
          onChange={(event) =>
            setFilters({
              ...filters,
              pagination: { page: 1, perPage: 8 },
              searchInput: convertPersianNumbersToEnglishNumbers(
                event.currentTarget.value
              )
            })
          }
        />
      </div>
      {/* <div className={classes.selectorContainer}>
        <AutocompleteWithLabel
          options={Object.entries(RolesLabels).map(([key, value]) => ({
            value: key,
            label: getTranslate(value)
          }))}
          inputSize="small"
          getOptionLabel={(option) => option.label || ''}
          value={autoCompleteForRole}
          onChange={(_, value: any) => {
            if (value) {
              setAutoCompleteForRele({
                value: value.value,
                label: value.label
              })
              setFilters({
                ...filters,
                pagination: { page: 1, perPage: 8 },
                entityCodes: [],
                role: value.value
              })
            } else {
              setAutoCompleteForRele(null)
              setFilters({
                ...filters,
                entityCodes: [],
                role: 'UNKNOWN_ROLE'
              })
            }
          }}
          label={getTranslate('Role')}
        />
        {autoCompleteForRole && autoCompleteForRole.value !== 'ADMIN' && (
          <EntityBox
            selectedRole={autoCompleteForRole && autoCompleteForRole.value}
            setFilters={setFilters}
          />
        )}
      </div> */}
    </div>
  )
}

export default UsersFilters
